<template>
<div>

      <v-divider></v-divider>

      <v-list dense flat class="navigation">
        <v-subheader>{{ $t("navigation.title") }}</v-subheader>
        <template v-for="(item, i) in menuData">
          <div v-if="item.group" :key="i"></div>
            <v-list-group
            v-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.icon"
            :append-icon="item['icon-alt']"
            no-action
            color="primary"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("navigation." + item.text) }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
              class="child"
              :class="{'item-line': child.line}"
            >

              <v-list-item-icon v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("navigation." + child.text) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

        <v-list-item-group v-else color="primary" :key="item.text">
          <v-list-item :to="item.link" >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("navigation." + item.text) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        </template>
      </v-list>

</div>
</template>

<script>
  import Auth from '../core/auth';
  export default {
    components: {

    },
    data () {
      return {
        clipped: false,
        drawer: true,
        fixed: true,
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'Dispatcher',
        menuData: []
      }
    },
    methods: {
      update () {
        this.menuData = this.$store.getters.menuData;
        if (!this.menuData.length) {
          Auth.logout();
          this.$router.push('/login');
        }
      }
    },
    created () {
      this.$bus.$on('login', () => {
        this.update();
      });
      this.update();
    }
  }
</script>
<style lang="scss">
.navigation {
  .v-list-group {
    position: relative;
    &.v-list-group--active:before,
    &.v-list-group--active:after {
      display: block;
      content: "";
      height: 1px;
      width: 100%;
      background: rgba(0,0,0,.12);
    }
  }
  .item-group{
    padding: 20px 0 10px 20px;
  }

  .item-line:after{

    content: "";
    height: 1px;
    position: absolute;
    bottom: 0;
    width: 100%;
    // background: rgba(0,0,0,.12);
    border-bottom: solid 1px rgba(0,0,0,.12);

  }

  .v-list-group__items>{
    display: block;
    .child.v-list-item  {
      padding: 0 30px;
    }
  }
}

</style>
